import { render, staticRenderFns } from "./Emergency-Contact.vue?vue&type=template&id=81e7c30e&scoped=true"
import script from "./Emergency-Contact.vue?vue&type=script&lang=js"
export * from "./Emergency-Contact.vue?vue&type=script&lang=js"
import style0 from "./Emergency-Contact.vue?vue&type=style&index=0&id=81e7c30e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e7c30e",
  null
  
)

export default component.exports